<template>
  <div>
      <div class="has-text-centered" style="margin-top: 1rem;">
          <button class="button is-large" @click="print()">{{'components.common.printer.print' | translate}}</button>
      </div>
      <div ref="slot" class="is-hidden">
        <slot></slot>
      </div>
      <iframe ref="frame" class="is-hidden" style="width: 100%; height: 500px;"></iframe>
  </div>
</template>

<script>
export default {
  methods: {
    getLinks () {
      const links = document.getElementsByTagName('link');
      let result = [];
      for (let i = 0; i < links.length; i++) {
        if (links[i].type === 'stylesheet') {
          result.push(links[i].outerHTML);
        }
      }
      return result.join('\n');
    },
    getStyles () {
      const styles = document.getElementsByTagName('style');
      let result = [];
      for (let i = 0; i < styles.length; i++) {
        result.push(styles[i].outerHTML);
      }
      return result.join('\n');
    },
    addClasses (elements) {
      for (let i = 0; i < elements.length; i++) {
        elements[i].className += ' has-background-white has-text-black';
        this.addClasses(elements[i].childNodes);
      }
    },
    print () {
      this.addClasses(this.$refs.slot.childNodes);
      this.$refs.frame.contentDocument.write('<html class="has-background-white has-text-black">');
      this.$refs.frame.contentDocument.write(this.getLinks());
      this.$refs.frame.contentDocument.write(this.getStyles());
      this.$refs.frame.contentDocument.write('<body class="has-background-white has-text-black">');
      this.$refs.frame.contentDocument.write(this.$refs.slot.innerHTML);
      this.$refs.frame.contentDocument.write('</body>');
      this.$refs.frame.contentDocument.write('<script>print()<'+'/script>');
      this.$refs.frame.contentDocument.write('</html>');
      this.$refs.frame.contentDocument.close();
    }
  }
}
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/printer/printer.vue